import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import AutoForm from 'App/components/AutoForm'
import ObjectField from 'App/components/fields/ObjectField'
import Fields from 'orionjs-react-autoform/lib/Fields'
import {Field} from 'simple-react-form'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import useRef from 'App/hooks/useRef'
import useForceLogin from 'App/hooks/useForceLogin'
import CorrectlySaved from './CorrectlySaved'
import capitalize from 'App/helpers/strings/capitalize'

export default function FinancialData(props) {
  useForceLogin()
  const bankDataButton = useRef()
  const billingDataButton = useRef()

  const {vehicle} = useQuery({
    query: gql`
      query getVehicleFinancialData {
        vehicle: myVehicle {
          _id
          bankData
          billingData
          fullName
          financialDataEdition {
            enabled
            message
          }
          country {
            code
            bankDataParams
            billingDataParams
          }
        }
      }
    `
  })

  if (!vehicle || !vehicle.financialDataEdition || !vehicle.country) return null

  if (vehicle.bankData && vehicle.billingData) return <CorrectlySaved vehicle={vehicle} />

  const canEditFinancialData = vehicle.financialDataEdition.enabled
  const canEditBankData = canEditFinancialData || !vehicle.bankData
  const canEditBillingData = canEditFinancialData || !vehicle.billingData

  const {country} = vehicle
  const {bankDataParams, billingDataParams} = country

  const bankDataDiv = bankDataParams ? (
    <div className={styles.form}>
      <AutoForm
        buttonRef={bankDataButton}
        mutation="setVehicleBankData"
        doc={{vehicleId: vehicle._id, bankData: vehicle.bankData, origin: 'web'}}
        disable={!canEditBankData}
        label="Guardar la información para mis pagos"
        title="Información para mis pagos"
        onSuccess={result => window.location.reload(true)}>
        <Field fieldName="bankData" type={ObjectField}>
          <Fields getFieldComponent={AutoForm.getFieldComponent} params={bankDataParams} />
        </Field>
      </AutoForm>
      <div className={styles.submitButton}>
        <Button primary ref={bankDataButton}>
          Guardar Información Bancaria
        </Button>
      </div>
    </div>
  ) : null

  const billingDataLabel =
    vehicle.countryCode === 'MX' ? 'Certificado de Sello Digital' : 'Datos de facturación'

  const billingDataDiv = billingDataParams ? (
    <div className={styles.form}>
      <AutoForm
        buttonRef={billingDataButton}
        mutation="setVehicleBillingData"
        doc={{vehicleId: vehicle._id, billingData: vehicle.billingData}}
        disable={!canEditBillingData}
        label={`Guardar ${billingDataLabel}`}
        title={capitalize(billingDataLabel)}
        onSuccess={result => window.location.reload(true)}>
        <Field fieldName="billingData" type={ObjectField}>
          <Fields getFieldComponent={AutoForm.getFieldComponent} params={billingDataParams} />
        </Field>
      </AutoForm>
      <div className={styles.submitButton}>
        <Button primary ref={billingDataButton}>
          {`Guardar ${billingDataLabel}`}
        </Button>
      </div>
    </div>
  ) : null

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src="https://orioneat.com/logo-dark.svg" alt="Logo" />
      </div>
      <div className={styles.title}>
        <p>Hola {vehicle.fullName}, completa tus datos bancarios y de facturación</p>
      </div>
      {bankDataDiv}
      {billingDataDiv}
    </div>
  )
}
